
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { addCurrencyUnit, addCurrencySymbol, formDownload } from "@common/src/utils/tools";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";

const partsCategory = namespace("parts-category");
const common_statement = namespace("common_statement");
const parts = namespace("parts");
@InjectFunction("emptyToLine", "dayjs", "splitThousands")
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class Parts extends Vue {
  @partsCategory.Action getCategoryList;
  @common_statement.Action queryPartsSalesList;
  @parts.Action getPartsBrandList;
  t = t;
  searchForm = {
    categoryCode: "",
    partsName: ""
  };
  hideCost: boolean = true;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  sortForm: {};
  salesList: any[] = [];
  get searchList() {
    return [
      {
        label: "parts.category",
        type: "cascader",
        prop: "categoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: "parts.name",
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("finance.receipt-time"),
        type: "daterange",
        value: "",
        prop: "paidTime",
        valueDistribute: ["paidBeginTime", "paidEndTime"]
      },
      {
        label: t("service.time-completion"),
        type: "daterange",
        value: "",
        prop: "completedTime",
        valueDistribute: ["completedBeginTime", "completedEndTime"]
      },
      {
        label: t("finance.guest-names"),
        type: "input",
        value: "",
        prop: "customerName"
      },
      {
        label: t("v210801.customer-mobile-number"),
        type: "input",
        value: "",
        prop: "customerMobile"
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      }
    ];
  }
  categoryList: any = [];
  created() {
    this.init();
  }
  async init() {
    this.loadListData();
    this.getBrandList();
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  listData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPartsSalesList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      partsName: this.searchForm.partsName
    }).then(data => {
      this.salesList = this.$safeValue(data, "data.list", []);
      this.listData = this.$safeValue(data, "data", {});
      return data;
    });
  }
  addLeafFlag(list) {
    if (!list) return;
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "categoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  brandList: any = [];
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  handleExportData() {
    formDownload(`${window.API_URL}/report/partsSalesReport/download`, this.searchForm);
  }
}
